import "objectFitPolyfill"

export default () => {
  const heros = document.querySelectorAll(".js-video-hero")
  const buttons = document.querySelectorAll(".js-play-fullscreen-video")
  const fullscreens = document.querySelectorAll(".js-fullscreen-video")
  const closeButtons = document.querySelectorAll(".js-close-fullscreen-video")
  const { body } = document
  ;[...heros].forEach(hero => {
    // Loop heros & test for autoplay
    const video = hero.querySelector("video")
    const overlay = hero.querySelector(".js-video-overlay")
    video.addEventListener("play", () => {
      // Test if autoplay is working, if it is hide background/overlary
      overlay.classList.add("c-video-hero__overlay--hidden")
    })
  })

  ;[...buttons].forEach(button => {
    button.addEventListener("click", function() {
      const parent = document.getElementById(this.dataset.target)
      const video = parent.querySelector("video")
      parent.classList.add("c-fullscreen-video--active")

      // scroll to top
      window.scrollTo(0, 0)

      body.classList.add("fullscreen-video-playing")

      // play video
      video.play()
    })
  })
  ;[...closeButtons].forEach(button => {
    button.addEventListener("click", () => {
      closeAll()
    })
  })

  document.addEventListener("keyup", e => {
    if (e.keyCode === 27) closeAll()
  })

  const closeAll = () => {
    ;[...fullscreens].forEach(fullscreen => {
      const video = fullscreen.querySelector("video")
      body.classList.remove("fullscreen-video-playing")
      fullscreen.classList.remove("c-fullscreen-video--active")
      video.pause()
      video.currentTime = 0
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/VideoHero.js